import BaseApiInstance from './base';
const BASE_URL = '/sync-jobs';

export const getJobsApi = async ({ params }) => {
  const response = await BaseApiInstance.get(`${BASE_URL}`, {
    params,
  });
  return response;
};
